// built-from: /application-navigation-shell v2 impl:application-navigation-shell role:implementation
// Spec 100, owner decision 11: under Activities the side navigation lists the
// activities this engagement actually has, taken from its plan, the way the
// Business map lists its processes. Decision 6 puts the Brief among them: it
// is an activity, and it needs no plan record to be one.
import { FileText } from 'lucide-react';
import type { AppShellNavigation } from '../components/AppShell';
import type { EngagementActivity } from '../hooks/useEngagementSetup';
import { engagementActivityDestination } from './engagementSpecialists';

const ACTIVITIES_ITEM = '/engagement/activities';

export function engagementActivityNavigation(
  navigation: AppShellNavigation,
  activities: readonly EngagementActivity[],
): AppShellNavigation {
  if (activities.length === 0) return navigation;
  const children = [
    { to: '/engagement/brief', label: 'Brief', Icon: FileText },
    ...activities.map((activity) => ({
      to: engagementActivityDestination(activity),
      label: activity.name,
      Icon: FileText,
    })),
  ];
  return {
    ...navigation,
    items: navigation.items.map((item) => (
      item.to === ACTIVITIES_ITEM ? { ...item, children } : item
    )),
  };
}
